<template>
  <div class="single-layer">
    <div class="switch-holder">
      <slot name="switch-holder"></slot>
      <ToggleSwitch layout-part="layer" :layer-id="layerId"></ToggleSwitch>
    </div>
    <slot></slot>
  </div>
</template>

<script>
import ToggleSwitch from '@/components/ToggleSwitch.vue';

export default {
  props: {
    layerId: {
      type: Number,
      required: true
    }
  },
  components: {
    ToggleSwitch
  },
  data() {
    return {};
  },
  methods: {}
};
</script>

<style scoped>
.single-layer {
  position: relative;
}
.single-layer details summary {
  padding-right: 2.4rem;
}
.switch-holder {
  position: absolute;
  top: 0.6rem;
  right: 0.5rem;
  z-index: 1;
}
</style>
